import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import Agreements from 'src/views/agencies/agreements'
import AntiFraud from 'src/views/Management/Administration/views/anti-fraud'
import Approvals from 'src/views/Requests/views/Approvals'
import ApprovalsSummary from 'src/views/Requests/views/ApprovalsSummary'
import Audits from 'src/views/Requests/views/Audits'
import AuditsSummary from 'src/views/Requests/views/AuditsSummary'
import Auth from 'src/views/Auth'
import Bedrooms from 'src/views/agencies/partners/bedrooms'
import Closings from 'src/views/Requests/views/Closings'
import ClosingsSummary from 'src/views/Requests/views/ClosingsSummary'
import Conferences from 'src/views/Requests/views/Conferences'
import ConferencesSummary from 'src/views/Requests/views/ConferencesSummary'
import DashBoard from 'src/views/dashboard'
import Error403 from 'src/views/Errors/Error403'
import Error404 from 'src/views/Errors/Error404'
import RequestClassification from 'src/views/Requests/views/request-classification'
import ExpenseClassification from 'src/views/Requests/views/expense-classification'
import FlowManagement from 'src/views/Management/Administration/views/flow'
import Form from 'src/views/Requests/views/Form'
import HelpVideos from 'src/views/help/videos'
import Issuances from 'src/views/agencies/issuances'
import IssuancesSummary from 'src/views/agencies/issuances-summary'
import ManageTenant from 'src/views/Management/tenant'
import ManageTenantForm from 'src/views/Management/tenant/form'
import MobileAccess from 'src/views/mobile-access'
import MyRequests from 'src/views/Requests/views/MyRequests'
import MyRequestsSummary from 'src/views/Requests/views/MyRequestsSummary'
import MyTeam from 'src/views/Management/MyTeam'
import Partners from 'src/views/agencies/partners'
import Policies from 'src/views/Management/policies'
import PolicyForm from 'src/views/Management/policies/form'
import Report from 'src/views/Management/Reports/components/Report'
import Reports from 'src/views/Management/Reports'
import Resources from 'src/views/Management/Administration/views/resources'
import TreeManagement from 'src/views/Management/Administration/views/tree'
import UserEmailNotifications from 'src/views/Management/Administration/views/user-email-notifications'
import UserForm from 'src/views/Management/users/form'
import Users from 'src/views/Management/users'
import DashboardRoute from './DashboardRoute'
import history from './history'

function Routes() {
  useEffect(() => {
    if (isMobile) {
      history.push('/mobile')
    }
  }, [])

  return (
    <Router history={history}>
      <Switch>
        <Route component={Auth} exact path="/" />
        <Route component={MobileAccess} exact path="/mobile" />
        <DashboardRoute
          component={Agreements}
          exact
          path="/agencies/agreements"
        />
        <DashboardRoute
          component={AntiFraud}
          exact
          path="/management/administration/antifraud"
        />
        <DashboardRoute component={Approvals} exact path="/approvals" />
        <DashboardRoute
          component={ApprovalsSummary}
          exact
          path="/approvals/:request_approval_id/request/:request_id"
        />
        <DashboardRoute component={Audits} exact path="/audits" />
        <DashboardRoute
          component={AuditsSummary}
          exact
          path="/audits/:request_id/summary"
        />
        <DashboardRoute
          component={Bedrooms}
          exact
          path="/agencies/partners/:partner_id/hotel/:hotel_id/bedrooms/:agency_partner_id"
        />
        <DashboardRoute component={Closings} exact path="/closings" />
        <DashboardRoute
          component={ClosingsSummary}
          exact
          path="/closings/:request_closing_id/request/:request_id"
        />
        <DashboardRoute component={Conferences} exact path="/conferences" />
        <DashboardRoute
          component={ConferencesSummary}
          exact
          path="/conferences/:request_conference_id/request/:request_id"
        />
        <DashboardRoute component={DashBoard} exact path="/dashboard" />
        <DashboardRoute
          component={ExpenseClassification}
          exact
          path="/expense-classification"
        />
        <DashboardRoute
          component={RequestClassification}
          exact
          path="/request-classification"
        />
        <DashboardRoute
          component={FlowManagement}
          exact
          path="/management/flow"
        />
        <DashboardRoute
          component={Form}
          exact
          path="/my-requests/create/reason/:reason_id"
        />
        <DashboardRoute component={HelpVideos} exact path="/help/videos" />
        <DashboardRoute
          component={Issuances}
          exact
          path="/agencies/issuances"
        />
        <DashboardRoute
          component={IssuancesSummary}
          exact
          path="/agencies/issuances/:request_agency_id/:request_id/:organization_id/summary"
        />
        <DashboardRoute component={ManageTenant} exact path="/tenant" />
        <DashboardRoute
          component={ManageTenantForm}
          exact
          path="/tenant/:tenant_id"
        />
        <DashboardRoute component={MyRequests} exact path="/my-requests" />
        <DashboardRoute
          component={MyRequestsSummary}
          exact
          path="/my-requests/:request_id/summary"
        />
        <DashboardRoute component={MyTeam} exact path="/management/my-team" />
        <DashboardRoute component={Partners} exact path="/agencies/partners" />
        <DashboardRoute component={Policies} exact path="/policies" />
        <DashboardRoute component={PolicyForm} exact path="/policies/create" />
        <DashboardRoute
          component={PolicyForm}
          exact
          path="/policies/edit/:policy_id"
        />
        <DashboardRoute
          component={Report}
          exact
          path="/management/reports/:report_id"
        />
        <DashboardRoute component={Reports} exact path="/management/reports" />
        <DashboardRoute
          component={Resources}
          exact
          path="/management/administration/resources/:resource"
        />
        <DashboardRoute
          component={TreeManagement}
          exact
          path="/management/tree"
        />
        <DashboardRoute
          component={UserEmailNotifications}
          exact
          path="/management/administration/email/notifications"
        />
        <DashboardRoute component={UserForm} exact path="/users/create" />
        <DashboardRoute
          component={UserForm}
          exact
          path="/users/edit/:user_id"
        />
        <DashboardRoute component={Users} exact path="/users" />
        <Route component={Error403} exact path="/403" />
        <Route component={Error404} exact path="/404" />
        <Redirect to="/404" />
      </Switch>
    </Router>
  )
}

export default Routes
